import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Message } from 'element-ui'
function getUser () {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (user && user.signInUserSession) {
        return user
      } else {
        return null
      }
    })
    .catch(err => {
      console.log(err)
    })
}

function getGroups () {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (user && user.signInUserSession) {
        return user.signInUserSession.accessToken.payload['cognito:groups']
      } else {
        return null
      }
    })
    .catch(err => {
      console.log(err)
    })
}

function getUserName () {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (user && user.signInUserSession) {
        return user.attributes.email.split('@')[0]
      } else {
        return null
      }
    })
    .catch(err => {
      console.log(err)
    })
}

function getEmail () {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (user && user.signInUserSession) {
        return user.attributes.email
      } else {
        return null
      }
    })
    .catch(err => {
      console.log(err)
    })
}

function getToken () {
  return Auth.currentSession()
    .then(session => {
      if (session) {
        return session.idToken.jwtToken
      } else {
        return null
      }
    })
    .catch(err => {
      console.log(err)
      return err
    })
}

function signUp (username, password) {
  return Auth.signUp({
    username,
    password,
    attributes: {
      email: username
    }
  })
    .then(data => {
      AmplifyEventBus.$emit('localUser', data.user)
      if (data.userConfirmed === false) {
        AmplifyEventBus.$emit('authState', 'login')
      } else {
        AmplifyEventBus.$emit('authState', 'signIn')
      }
      return data
    })
    .catch(err => {
      console.log(err)
    })
}

function confirmSignUp (username, code) {
  return Auth.confirmSignUp(username, code)
    .then(data => {
      AmplifyEventBus.$emit('authState', 'signIn')
      return data // 'SUCCESS'
    })
    .catch(err => {
      console.log(err)
    })
}

function resendSignUp (username) {
  return Auth.resendSignUp(username)
    .then(() => {
      return 'SUCCESS'
    })
    .catch(err => {
      console.log(err)
    })
}

async function signIn (username, password) {
  try {
    const user = await Auth.signIn(username, password)
    if (user) {
      AmplifyEventBus.$emit('authState', 'signedIn')
    }
  } catch (err) {
    if (err.code === 'UserNotConfirmedException') {
      Message({
        message: 'Хэрэглэгчийг баталгаажуулаагүй байна.!',
        duration: 2500,
        type: 'error',
        showClose: 1
      })
      setTimeout(function () {
        location.reload()
      }, 3000)
    } else if (err.code === 'PasswordResetRequiredException') {
      Message({
        message: 'Хэрэглэгчийг нууц үгийг сэргээх шаардлагтай.!',
        duration: 2500,
        type: 'error',
        showClose: 1
      })
      setTimeout(function () {
        location.reload()
      }, 3000)
    } else if (err.code === 'NotAuthorizedException') {
      setTimeout(function () {
        location.reload()
      }, 3000)
    } else if (err.code === 'UserNotFoundException') {
      Message({
        message: 'Хэрэглэгчийн нууц үг эсвэл имэйл буруу байна.!!',
        duration: 2500,
        type: 'error',
        showClose: 1
      })
      setTimeout(function () {
        location.reload()
      }, 3000)
    }
    return err
  }
}

function signOut () {
  return Auth.signOut()
    .then(data => {
      AmplifyEventBus.$emit('authState', 'signedOut')
      return data
    })
    .catch(err => {
      console.log(err)
    })
}
function checkRoles (role, ownRole) {
  let isFound = false
  ownRole.forEach(element => {
    if (role.includes(element)) {
      isFound = true
    }
  })
  console.log('rolee', role, isFound)
  return isFound
}
async function checkCurrentUserExist () {
  return Auth.currentUserInfo()
    .then(async data => {
      if (!data || !Object.prototype.hasOwnProperty.call(data, 'username')) {
        await Auth.signOut()
        AmplifyEventBus.$emit('authState', 'signedOut')
      }
      return data
    })
    .catch(async () => {
      await Auth.signOut()
      AmplifyEventBus.$emit('authState', 'signedOut')
    })
}
export {
  getUser,
  signUp,
  confirmSignUp,
  resendSignUp,
  signIn,
  signOut,
  getToken,
  getGroups,
  getUserName,
  getEmail,
  checkRoles,
  checkCurrentUserExist
}
